import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../../../../utilities/classNames";
import CardBase from "../../bases/CardBase";
import Eyebrow from "../../../../../elements/Eyebrow";

var QuoteCard = function QuoteCard(_ref) {
  var attribution = _ref.attribution,
      borderless = _ref.borderless,
      eyebrow = _ref.eyebrow,
      href = _ref.href,
      text = _ref.text,
      id = _ref.id;
  var getClassName = getClassNameFactory(QuoteCard.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement(CardBase, {
    borderless: borderless,
    id: id,
    href: href,
    size: "large"
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "content"
    })
  }, eyebrow ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "eyebrow"
    })
  }, /*#__PURE__*/React.createElement(Eyebrow, {
    text: eyebrow
  })) : null, /*#__PURE__*/React.createElement("blockquote", {
    className: getClassName({
      descendantName: "quote"
    })
  }, text), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "attribution"
    })
  }, attribution))));
};

QuoteCard.displayName = "QuoteCard";
QuoteCard.sizes = CardBase.sizes;
/* eslint-disable max-len */

QuoteCard.propTypes = {
  /**
   * Attribution component for attributing the quotation
   */
  attribution: PropTypes.node.isRequired,

  /**
   * Hide the border
   */
  borderless: PropTypes.bool,

  /**
   * Eyebrow text
   */
  eyebrow: PropTypes.string,

  /**
   * Card URL
   */
  href: PropTypes.string,

  /**
   * The quotation
   */
  text: PropTypes.string.isRequired,

  /**
   * id to identity component for Selenium Test
   */
  id: PropTypes.string
};
/* eslint-enable max-len */

QuoteCard.defaultProps = {
  borderless: false,
  size: "large"
};
export default QuoteCard;